module.exports = __webpack_public_path__ + "img/P1010343.e6f4eb3b.jpeg";